import React, { useState } from 'react';
import { Button, Checkbox, Header, Icon, List, Segment, Table } from 'semantic-ui-react';
import TierLabel from '../subcomponents/TierLabel';
import { RECOMMENDATION_TIERS } from '../constants';

const ConfirmTeamSetup = ({ teams, roles, invites, isApprovedInitially = false, nextStepTitle = 'Phone System', onBack, onConfirm }) => {
    const [isApproved, setIsApproved] = useState(isApprovedInitially);

    const getRoleName = (role_id) => roles.find(({ id }) => id === role_id)?.name || '';
    const getTeamNames = (team_ids = []) => team_ids.map(team_id => teams.find(({ id }) => id === team_id)?.name).filter(Boolean).join(', ');

    return (
        <Segment>
            <Header as='h3'>
                Confirm Your Team Setup
                <Header.Subheader>These are saved as a draft and won't change your account until launch.</Header.Subheader>
            </Header>

            <Header as='h4'>Teams ({teams.length})</Header>
            <List divided relaxed>
                {teams.map(({ id, name, purpose }) => {
                    const memberCount = invites.filter(({ team_ids }) => (team_ids || []).includes(id)).length;
                    return (
                        <List.Item key={id}>
                            <List.Icon name='users' color='blue' />
                            <List.Content>
                                <List.Header>{name}</List.Header>
                                <List.Description>{purpose || 'Custom team'} · {memberCount} invited</List.Description>
                            </List.Content>
                        </List.Item>
                    );
                })}
            </List>

            <Header as='h4'>Access Roles ({roles.length})</Header>
            <List divided relaxed>
                {roles.map(({ id, name, permissions }) => (
                    <List.Item key={id}>
                        <List.Icon name='key' color='blue' />
                        <List.Content>
                            <List.Header>{name}</List.Header>
                            <List.Description>{permissions.length ? permissions.join(' · ') : 'Standard DYL role'}</List.Description>
                        </List.Content>
                    </List.Item>
                ))}
            </List>

            <Header as='h4'>Invitations ({invites.length}) <TierLabel tier={RECOMMENDATION_TIERS.REQUIRES_ACTIVATION} /></Header>
            {invites.length ? (
                <Table compact unstackable={false}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Name</Table.HeaderCell>
                            <Table.HeaderCell>Email</Table.HeaderCell>
                            <Table.HeaderCell>Role</Table.HeaderCell>
                            <Table.HeaderCell>Teams</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {invites.map(({ first_name, last_name, email, role_id, team_ids }) => (
                            <Table.Row key={email}>
                                <Table.Cell>{first_name} {last_name}</Table.Cell>
                                <Table.Cell>{email}</Table.Cell>
                                <Table.Cell>{getRoleName(role_id)}</Table.Cell>
                                <Table.Cell>{getTeamNames(team_ids) || '—'}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            ) : (
                <p>No invitations yet. You can invite people later from Settings → Users.</p>
            )}

            <Segment secondary>
                <Checkbox
                    checked={isApproved}
                    onChange={(_, { checked }) => setIsApproved(checked)}
                    label="I've reviewed this team setup and approve it as my configuration draft"
                />
            </Segment>
            <Button basic type='button' onClick={onBack}><Icon name='arrow left' /> Back</Button>
            <Button primary floated='right' type='button' disabled={!isApproved} onClick={onConfirm}>
                Continue to {nextStepTitle} <Icon name='arrow right' />
            </Button>
            <div style={{ clear: 'both' }} />
        </Segment>
    );
}

export default ConfirmTeamSetup;
